<template>
	<div class="tab-accordian">
		<a
			v-bind:class="'titleWrapper ' + isActive"
			v-on:click="toggle"
			v-on:keypress="toggle"
			tabindex="0">
			<h3>{{ title }}</h3>
			<div class="collapse-icon">
				<div class="acc-close"></div>
				<div class="acc-open"></div>
			</div>
		</a>
		<div
			id="descwrapper"
			class="desWrapper"
			v-show="showSection"
			v-html="introduction"></div>
		<div
			v-if="$i18n.locale == 'zh-TW'"
			class="docWrapper"
			v-show="showSection">
			<InertiaLink
				v-for="doc in docs"
				:key="doc.title"
				class="docs-btn"
				:href="'/docs/' + doc.document_id"
				>{{ doc.title }}</InertiaLink
			>
		</div>
		<div v-else class="docWrapper" v-show="showSection">
			<InertiaLink
				v-for="doc in docs"
				:key="doc.title"
				class="docs-btn"
				:href="'/docs/' + doc.document_id"
				>{{ doc.title_en }}</InertiaLink
			>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isActive: "inactive",
			showSection: false,
		};
	},
	methods: {
		toggle() {
			this.showSection = !this.showSection;
			if (this.showSection) {
				this.isActive = "active";
			} else {
				this.isActive = "inactive";
			}
		},
	},
	props: {
		title: String,
		introduction: String,
		docs: Object,
	},
};
</script>

<style scoped>
h3 {
	font-family: Poppins, Tahoma, sans-serif;
	font-size: 1rem;
	font-weight: 700;
	line-height: 20px;
	color: #4d4e58;
	margin: 0;
}

ul li,
.tab-accordian p {
	font-weight: 400;
	font-size: 0.88rem;
	line-height: 20px;
	color: #4e4e4e;
	font-family: Inter, Tahoma, sans-serif;
}

.tab-accordian a {
	color: #60bdb2;
	text-decoration: none;
	cursor: pointer;
}

.tab-accordian ul {
	padding-left: 22px;
}
.tab-accordian p {
	margin-top: 0;
}

.tab-accordian {
	width: 100%;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px solid #cecece;
	background: #ffffff;
	margin-bottom: 20px;
	overflow: hidden;
}

.titleWrapper {
	padding: 20px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #fff;
	-webkit-user-select: none;
	user-select: none;
	transition: background-color 0.8s linear;
}

.desWrapper {
	background: #fff;
	color: #4e4e4e;
	max-height: 500px;
	padding: 20px 20px 0px 20px;
	transition: max-height 1s ease-in;
}

.docWrapper {
	background: #fff;
	color: #4e4e4e;
	max-height: 500px;
	padding: 0px 20px 20px 20px;
	transition: max-height 1s ease-in;
}

/* Collapse Icon */

.collapse-icon {
	position: relative;
}
.collapse-icon .acc-close {
	height: 20px;
	border-left: 2px solid #0a7a7f;
	transition: all 0.5s ease-in-out;
	transform: rotate(-90deg);
	opacity: 1;
}

.collapse-icon .acc-open {
	width: 19px;
	position: absolute;
	border-top: 2px solid #0a7a7f;
	transition: all 0.5s ease-in-out;
	transform: rotate(90deg);
	top: 43%;
	right: -8px;
}

.titleWrapper.active .collapse-icon {
	transition: all 0.5s ease-in-out;
	transform: rotate(180deg);
}

.titleWrapper.inactive .collapse-icon {
	transition: all 0.5s ease-in-out;
	transform: rotate(-180deg);
}

.titleWrapper.active .collapse-icon .acc-open {
	opacity: 0;
}

.docs-btn {
	border: 1px solid #60bdb2;
	color: #60bdb2;
	display: inline-block;
	margin: 8px;
	font-size: 0.88rem;
	border-radius: 25px;
	padding: 8px 20px;
	text-align: center;
	transition: all 0.3s ease;
	letter-spacing: 0.4px;
}

.docs-btn:hover,
.docs-btn:focus {
	color: #ffffff;
	background: #50bdb2;
}
</style>
